import Component from "../abstracts/Component";
import ChatUtils from "../utils/ChatUtils";
import { trapFocusOnModal, removeTrapFocusOnModal } from "../utils/TrapFocus";

/**
 Chat component
 */
export default class ChatComponent extends Component {
  constructor() {
    super();
    this.personalStylistPopup = null;
    this.closeBtn = null;
    this.startChat = null;
    this.trapFocusHandler = null;
    this.lastActiveElement = null;
    this.isPopupAccessibilityActive = false;
    this.popupObserver = null;
  }

  bindEvents() {
    // contact us button
    let liveChatButton = document.querySelector("a[data-name=live-chat]");

    // button online
    this.$on("chatButtonEnabled", e => {
      if (liveChatButton != null) {
        liveChatButton.classList.remove("not-available");
        liveChatButton.classList.add("available");
      }
    });
    // button offline
    this.$on("chatButtonDisabled", e => {
      if (liveChatButton != null) {
        liveChatButton.classList.add("not-available");
        liveChatButton.classList.remove("available");
        liveChatButton.removeEventListener("click", function() {});
      }
    });
  }

  setupPersonalStylistPopupAccessibility() {
    if (!this.personalStylistPopup || !this.closeBtn || !this.startChat) return;
    // Setup ESC key listener
    this.handleEscKey = e => {
      if (
        e.key === "Escape" &&
        !this.personalStylistPopup.classList.contains("d-none")
      ) {
        this.closeBtn.click(); // Use existing close button logic
      }
    };
    document.addEventListener("keydown", this.handleEscKey);
    // Monitor popup visibility changes to manage focus trap
    this.observePopupVisibility();
  }

  observePopupVisibility() {
    if (!this.personalStylistPopup) return;
    // Use MutationObserver to watch for class changes
    this.popupObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isVisible = !this.personalStylistPopup.classList.contains(
            "d-none"
          );

          if (isVisible && !this.isPopupAccessibilityActive) {
            this.activatePopupAccessibility();
          } else if (!isVisible && this.isPopupAccessibilityActive) {
            this.deactivatePopupAccessibility();
          }
        }
      });
    });

    this.popupObserver.observe(this.personalStylistPopup, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  activatePopupAccessibility() {
    if (!this.personalStylistPopup || this.isPopupAccessibilityActive) return;
    // Store the currently focused element to restore later
    this.lastActiveElement = document.activeElement;
    // Update ARIA attributes
    this.personalStylistPopup.setAttribute("aria-hidden", "false");
    // Set up focus trap
    this.trapFocusHandler = trapFocusOnModal(this.personalStylistPopup);
    // Focus on the close button
    requestAnimationFrame(() => {
      if (this.startChat) {
        this.startChat.focus();
      }
    });
    this.isPopupAccessibilityActive = true;
  }

  deactivatePopupAccessibility() {
    if (!this.personalStylistPopup || !this.isPopupAccessibilityActive) return;
    // Remove focus trap
    if (this.trapFocusHandler) {
      removeTrapFocusOnModal(this.personalStylistPopup, this.trapFocusHandler);
      this.trapFocusHandler = null;
    }
    // Update ARIA attributes
    this.personalStylistPopup.setAttribute("aria-hidden", "true");
    // Restore focus to previous element
    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
      this.lastActiveElement = null;
    }
    this.isPopupAccessibilityActive = false;
  }

  /////
  render() {
    this.log("rendering...");
    // some events
    this.bindEvents();
    // check if new chat is enabled
    let chatEnabled =
      document.querySelector("#chatEnabled") != null
        ? document.querySelector("#chatEnabled").value
        : false;
    // if is enabled let's launch it
    if (chatEnabled == "true") {
      // script call
      let script =
        ChatUtils.getValue("urlEnvironmentSF") +
        "/embeddedservice/5.0/esw.min.js";
      // get script and initialize chat
      this.moduleLoader.loadExternalScript(script).then(() => {
        this.log("loading...");
        let options = {
          selectors: {
            startChatLink: "a[data-name=live-chat]",
            chatLabelOnline: "#chatLabelOnlineNew"
          },
          subjects: {
            chatLabelSubject: "",
            chatLabelSubjectOptionOD: "Orders and deliveries",
            chatLabelSubjectOptionPay: "Payment, promotions and Gift Cards",
            chatLabelSubjectOptionCS: "Comments and Suggestions",
            chatLabelSubjectOptionPAv: "Product information and availability",
            chatLabelSubjectOptionSt: "Stores",
            chatLabelSubjectOptionRR: "Refunds and Returns",
            chatLabelSubjectOptionTA: "Technical assistance"
          },
          ctaClasses: ["cta", "cta-primary", "cta-full-width"],
          ctaTemplate:
            '<span class="bg-top"></span><span data-cta-text=":label:" class="text">:label:</span><span class="bg-bottom"></span>'
        };
        if (ChatUtils.getValue("personalStylistSnapConfig")) {
          options.subjects = ChatUtils.addToObject(
            options.subjects,
            "chatLabelSubjectOptionPS",
            "Personal Stylist",
            1
          );
        }
        // setup env
        ChatUtils.setEnvironment(options);
        // update cookie path
        ChatUtils.updatePath();
        // init the chat
        ChatUtils.initializeChat();
        // new chat modifier
        ChatUtils.runsNewChat();
      });
      // Initialize personal stylist popup accessibility
      this.personalStylistPopup = document.querySelector(
        ".live-chat-personal-stylist-cta__wrapper"
      );
      if (this.personalStylistPopup) {
        this.closeBtn = this.personalStylistPopup.querySelector(".vex-close");
        this.startChat =
          this.personalStylistPopup.querySelector(".start-chat") ||
          this.personalStylistPopup.querySelector(".start-whatsapp");
        this.setupPersonalStylistPopupAccessibility();
      }
    }
  }
}
